// src/components/store/sections/product-cards/Variant28EditorialCoverLimeZestCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingBag, ArrowUpRight, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant28EditorialCoverLimeZestCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    added,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full bg-[#faf8f5] rounded-[28px] border border-stone-200 p-4 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between group select-none">
      <div>
        <div className="flex items-center justify-between border-b border-stone-200 pb-2 mb-3">
          <span className="text-[9px] font-serif italic uppercase tracking-widest text-lime-800 font-bold">
            EDITION NO. 28
          </span>
          <span className="flex items-center gap-0.5 text-[10px] font-bold text-amber-600">
            <Star className="w-3 h-3 fill-amber-400 text-amber-400" /> {rating.toFixed(1)}
          </span>
        </div>
        <Link href={productUrl} className="relative w-full h-44 rounded-2xl bg-white border border-stone-200/70 flex items-center justify-center p-3 mb-3 block">
          <Image src={productImg} alt={productName} fill unoptimized className="object-contain p-2 group-hover:scale-105 transition-transform duration-500" />
        </Link>
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <span className="text-[9px] uppercase tracking-widest text-stone-400 block truncate">{categoryName}</span>
            <Link href={productUrl} className="block">
              <h3 className="text-sm font-serif font-bold text-stone-900 truncate hover:underline">{productName}</h3>
            </Link>
          </div>
          <Link href={productUrl} className="w-7 h-7 rounded-full bg-lime-50 text-lime-800 flex items-center justify-center shrink-0">
            <ArrowUpRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>

      <div className="pt-3 mt-3 border-t border-stone-200 flex items-center justify-between gap-2">
        <span className="text-base font-black font-mono text-stone-900">৳{currentPrice.toLocaleString()}</span>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="px-4 py-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-black text-[10px] uppercase tracking-wider shadow-xs active:scale-95 transition-all cursor-pointer flex items-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingBag className="w-3.5 h-3.5" />}
          <span>{added ? "Collected" : "Collect"}</span>
        </button>
      </div>
    </div>
  );
}
